export const AdminFeedbackSection = ({ claimStatus, adminComments, processedAt, processedBy }) => {
  if (claimStatus !== 'returned') return null;

  return (
    <div className="bg-orange-50 border border-orange-200 rounded-xl p-6 max-sm:p-4 mb-6 max-sm:mb-4">
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 sm:gap-4 mb-3 sm:mb-4">
        <h3 className="text-lg font-semibold text-orange-800"> Administrator Feedback</h3>
        <div className="flex flex-col sm:flex-row sm:flex-wrap gap-0.5 sm:gap-4 min-w-0 text-sm text-orange-700">
          <span>Returned on: {new Date(processedAt).toLocaleDateString()}</span>
          {processedBy && <span className="break-words">By: {processedBy}</span>}
        </div>
      </div>

      {adminComments && (
        <div className="bg-white rounded-lg p-3 sm:p-4 mb-3 sm:mb-4 border border-orange-200">
          <h4 className="font-semibold text-gray-800 mb-2">Overall Comments:</h4>
          <div className="text-gray-700 whitespace-pre-wrap break-words">
            {adminComments}
          </div>
        </div>
      )}

      <div className="bg-orange-100 rounded-lg p-3 sm:p-4">
        <p className="text-sm text-orange-800">
          <strong>Instructions:</strong> Please review the feedback above and any line-item comments below.
          Make the necessary changes and resubmit your claim.
        </p>
      </div>
    </div>
  );
};
